import request from "superagent";
import { useAuthStore } from "../stores/auth";

for (let k of ["get", "post", "put", "patch", "delete", "head"]) {
  let f = request[k];
  request[k] = function () {
    return f
      .apply(this, arguments)
      .set("Authorization", `Bearer ${localStorage.getItem("token")}`)
      .accept("json")
      .on("error", (err) => {
        if (err.status === 401) {
          localStorage.removeItem("token");
          useAuthStore.setState({ me: null, isLoading: false });
        }
      });
  };
}

export default request;
